import * as React from "react";
import { useEffect } from 'react'
import './App.css';
import './css/hover.css';

import { Admin, Resource, Sidebar } from 'react-admin';
import { addSearchMethod } from '@react-admin/ra-search';

import { dataProvider } from "./data/dataProvider";

import { AdminUserCreate, AdminUserEdit, AdminUserList, AdminUserShow } from "./panels/adminUsers/AdminUsers";
import _LoginPage from "./components/LoginPage";
import { AuthProvider } from "./auth/authProvider";
import { theme } from "./style/theme2";
// import { theme3 } from "./style/theme3";

import { i18nProvider } from "./i18n/i18nProvider";
import MyLayout from "./components/Layout";
// import Reportstat from './panels/Reportstat';


import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { ROLES } from "./constants";
import { MenuCategories } from "./constants/menuCategories";



import closeSidebarSaga from './closeSidebarSaga'



import { RTL } from "./style/rtl";

import Notification from './firebase/Notification'
import { InsertPaybillList, InsertPaybillCreate, InsertPaybillShow } from "./panels/hr/insertPaybill/InsertPaybill";
import { PaybillsList, PaybillsShow } from "./panels/hr/paybills/Paybills";
import { RequestList, RequestCreate, RequestShow, RequestEdit } from "./panels/hr/requests/Requests";

const CustomSidebar = (props) => <Sidebar {...props} size={200} />;

// const realTimeDataProvider = addRealTimeMethodsBasedOnMercure(
//   // original dataProvider

//   dataProvider,
//   // Mercure hub url
//   "http://193.176.242.199:8085/.well-known/mercure",
//   // JWT token to authenticate against the Mercure Hub
//   "eyJhbGciOiJIUzI1NiJ9.eyJtZXJjdXJlIjp7InB1Ymxpc2giOlsiKiJdLCJzdWJzY3JpYmUiOlsiKiJdfX0.UpIm0R5Now5UkzTU-ityvUreYpNIdvERValXvpMXEPA"
// );
// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const dataProviderWithSearch = addSearchMethod(dataProvider, {
  'contact': {
    label: 'name',
    description: record =>
      // `${record.phoneNumbers[0].number}`,
      `${record.phoneNumbers.map(a => a.number)}`,

    customData: record =>
      `${record}`,

  },
  // 'need': {
  //   label: 'title',
  //   description: record =>
  //     `از طرف - ${record.ownerName}`,
  //   customData: record =>
  //     `${record}`,
  // },
  // 'storage': {
  //   label: 'title',
  //   description: record =>
  //     `- <a href=${record.url}>دریافت</a>`,
  // },


});


// Initialize Firebase
const App = () => {
  useEffect(() => {
  }, []);

  return (
    <RTL>
      <Admin
        customSagas={[closeSidebarSaga]}
        sidebar={CustomSidebar}

        loginPage={_LoginPage}
        dataProvider={dataProviderWithSearch}
        authProvider={AuthProvider}
        // isMobile ? MyTheme :
        theme={theme}
        i18nProvider={i18nProvider}
        title="Mozaffari Admin Panel"
        layout={MyLayout}
      // dashboard={Dashboard}

      // dashboard={Dashboard}
      >
        {permissions => [


          <Resource
            name="paybills"
            dataProvider={dataProvider}
            list={PaybillsList}
            show={PaybillsShow}
            icon={<MonetizationOnIcon />}
            options={{
              category: MenuCategories.paybill, label: ' فیش حقوقی',
              //  permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN,ROLES.USER_EXPERIMENTAL, ROLES.MARKETING_ADMIN , ROLES.USER_EXPERIMENTAL,ROLES.HR_ADMIN,ROLES.HR_PANEL_ADMIN] 
              permissions: ["ALL"]
            }}
          />
          ,

          <Resource
            name="insertPaybill"
            dataProvider={dataProvider}
            list={InsertPaybillList}
            create={InsertPaybillCreate}
            show={InsertPaybillShow}
            icon={<RequestQuoteIcon />}
            options={{ category: MenuCategories.paybill, label: 'ورود اطلاعات', permissions: [ROLES.HR_ADMIN] }}
          />,
          <Resource
            name="adminUsers"
            dataProvider={dataProvider}
            list={AdminUserList}
            create={AdminUserCreate}
            edit={AdminUserEdit}
            show={AdminUserShow}
            icon={<SupervisorAccountIcon />}
            options={{ category: MenuCategories.admin, label: 'همکاران', permissions: [ROLES.HR_ADMIN, ROLES.HR_PANEL_ADMIN, ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="request"
            dataProvider={dataProvider}
            list={RequestList}
            create={RequestCreate}
            edit={RequestEdit}
            show={RequestShow}
            icon={<RequestQuoteIcon />}
            options={{
              category: MenuCategories.paybill,
              label: 'درخواست‌ها',
              permissions: ["ALL"] // Or specific permissions like [ROLES.HR_ADMIN, ROLES.ROOT]
            }}
          />,

        ]}

      </Admin>
      <Notification />

    </RTL>
  )
};

export default App;